<!--接收联合登录信息-->
<template>
	<div>
	正在获取您的用户信息请稍后
	</div>
</template>

<script>
	import api from '../../api'
	import { mapMutations, mapGetters } from 'vuex'
	
	export default {
    data(){
      return{
				//参数
				params:'',
			}
		},
		activated(){
			this.params = this.$route.query
			this.checkOAuth()
		},
		methods: {
			...mapMutations([
				'setG_UserInfo'
			]),
			checkOAuth(){
				var params = new this.URLSearchParam();
        params.append('code', this.params.code);
        params.append('state', this.params.state);
				this.$http.post(api.CheckOAuth(),params.toParam()).then((res) => {
					if(res.Result){
						this.saveUserInfo(res.Data)
						this.$router.push({ path: '/user/UserCenter' })
					}
					else{
						if(res.Message == '用户尚未绑定信息'){
							this.$router.push({ path: '/uniteLogin/bindAccount' })
						}
						else{
							this.$router.push({ path: '/user/Login' })
						}	
					}
				})
			},
			saveUserInfo(result) {// 保存登录信息
				// 保存登录信息
				var UserInfo = this.g_UserInfo;
				if (result.Card_Kind_Diplay == '网上数字卡') {
					result.Card_Kind_Diplay = '数字卡';
				}
				UserInfo.OrderRefresh1 = true;
				UserInfo.OrderRefresh2 = true;
				UserInfo.OrderRefresh3 = true;
				UserInfo.Card_Kind_Diplay = result.Card_Kind_Diplay;
				UserInfo.Card_no = result.Card_no;
				UserInfo.Name = result.Name;
				UserInfo.Sex = result.Sex;
				UserInfo.sjno = result.sjno;
				UserInfo.Email = result.Email;
				UserInfo.Card_Money = result.Card_Money;
        UserInfo.StoredValueCard_Money = result.StoredValueCard_Money;
        UserInfo.HasOpenStoreCard = result.HasOpenStoreCard
				UserInfo.MallCoin = result.MallCoin;
				UserInfo.isSignInedToday = result.isSignInedToday;
				this.setG_UserInfo(UserInfo)
    	},
		},
		computed: {
			...mapGetters([
				'g_UserInfo', 'g_loginInfo'
			])
		},
	}
</script>


// WEBPACK FOOTER //
// UniteAccept.vue?12a9186f